import { useState, useEffect } from 'react';
import api from '../../services/api';
import {
  Container,
  List,
  FlexboxGrid,
  InputGroup,
  ButtonGroup,
  Whisper,
  Popover,
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import { FaBoxOpen, FaEdit, FaFileImage } from 'react-icons/fa';
import { NotificationManager } from 'react-notifications';
import '../style.css';
import GaleriaImagens from './GaleriaImagens';
import CadastrarProduto from './EditarCadastrar';
import debounce from 'lodash/debounce';
import PlusIcon from '@rsuite/icons/Plus';
import FlexboxGridItem from 'rsuite/esm/FlexboxGrid/FlexboxGridItem';
import CadastrarGrupo from '../Grupo/EditarCadastrar';
import { useConfig } from '../../hooks/config';
import { useAuth } from '../../hooks/auth';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomInput } from '../../components/CustomInput';
import { CustomSelectPicker } from '../../components/CustomSelectPicker';
import { CustomButton } from '../../components/CustomButton';
import { CustomPanel } from '../../components/CustomPanel';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { useAlert } from '../../contexts/Alert.context';
import { mapNewStateList } from '../../utils/mapState';
import { IMAGES_PATH } from '../../utils/imagesPath';
import moment from 'moment';

export default function Produto() {
  const { id_empresa } = useAuth();
  const config = useConfig();
  const { theme } = useCustomTheme();

  const [produtos, setProdutos] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [buscar, setBuscar] = useState('');
  const [itemEdit, setItemEdit] = useState(null);
  const [grupoEdit, setGrupoEdit] = useState(null);

  const [filtroStatus, setFiltroStatus] = useState('');
  const [modalEditarCadastrar, setModalEditarCadastrar] = useState(false);
  const [modalImagem, setModalImagem] = useState(false);
  const [modalGrupo, setModalGrupo] = useState(false);
  const [grupoSelecionado, setGrupoSelecionado] = useState(null);
  const { showAlert } = useAlert();

  const styleCenter = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '90px',
  };

  const styleTitleCardGroup = {
    display: 'flex',
    alignItems: 'center',
    height: '55px',
  };

  const slimText = {
    fontSize: '0.800em',
    color: '#97969B',
    fontWeight: 'lighter',
    paddingBottom: 5,
  };

  const mediumText = {
    fontSize: '1em',
    color: '#97969B',
    fontWeight: 'lighter',
    paddingBottom: 5,
  };

  const titleStyle = {
    paddingBottom: 2,
    whiteSpace: 'nowrap',
    fontWeight: 500,
  };

  const styleImagem = {
    backgroundColor: '#fff',
    width: 'auto',
    maxWidth: '90px',
    height: 'auto',
    maxHeight: '90px',
    borderRadius: '10px',
    cursor: 'pointer',
  };

  const noImageStyle = {
    width: '90px',
    height: '90px',
    borderRadius: '10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const debounceSearch = debounce((valor) => {
    let instrucao = '';
    const value_lower = valor?.toLowerCase();

    instrucao +=
      filtroStatus !== '' ? ` p.Ativo=${filtroStatus}` : ` p.Ativo in (1,0)`;
    instrucao += value_lower
      ? ` AND LOWER(p.Descricao) LIKE '%${value_lower}%'`
      : ``;
    consultar(instrucao);
    setBuscar(valor);
  }, 800);

  const atualizar = async () => {
    api
      .get(`grupo-produto/listarGestor/${id_empresa}?active=1`)
      .then((res) => {
        setGrupos(res.data);
      })
      .catch((error) => console.log({ error }));
    consultar(' p.Id IS NOT NULL');
  };

  const consultar = async (consulta = ' p.Id IS NOT NULL') => {
    consulta += " AND p.TipoProduto != 'BORDA'";
    await api
      .post('produto/listarPorGrupoGestor', {
        IdEmpresa: id_empresa,
        Consulta: consulta,
      })
      .then((res) => {
        res.data.length > 0 ? setProdutos(res.data) : setProdutos([]);
      })
      .catch((error) => console.log({ error }));
  };

  const inserirFoto = (produto) => {
    setItemEdit(produto);
    setModalImagem(true);
  };

  const ativarDesativarProduto = async (valor, idProduto) => {
    const { data } = await api.post('produto/alterarStatus', {
      Ativo: valor,
      Id: idProduto,
    });

    setProdutos(mapNewStateList(data.Id, data));
  };

  const disponibilizar = async (valor, idProduto) => {
    const { data } = await api.post('produto/alterarDisponibilidade', {
      Disponivel: valor,
      Id: idProduto,
    });

    setProdutos(mapNewStateList(data.Id, data));
    NotificationManager.info('Alterado', 'Informação');
  };

  const editarProduto = (item) => {
    setItemEdit(item);
    setModalEditarCadastrar(true);
  };

  const editCategory = (grupo) => {
    setGrupoEdit(grupo);
    setModalGrupo(true);
  };

  const dataAtivos = [
    { label: 'Ver todos', value: '' },
    { label: 'Filtrar: Ativos', value: 1 },
    { label: 'Filtrar: Excluidos', value: 0 },
  ];

  const handleActiveGroupMenu = async (group) => {
    try {
      if (!group.Id) {
        throw new Error('Group Id must be provided');
      }

      const menuActive = group?.CardapioAtivo ? 0 : 1;

      const { data } = await api.patch(`grupo-produto/alterar/${group.Id}`, {
        CardapioAtivo: menuActive,
      });

      setGrupos(mapNewStateList(data.Id, data));
    } catch (error) {
      console.log(error);
    }
  };

  const handleShowAlertActiveMenu = (group) => {
    showAlert({
      title: '',
      text: `Deseja realmente ${
        group.CardapioAtivo ? 'desativar' : 'ativar'
      } categoria?`,
      submitText: 'Sim',
      onSubmit: () => {
        handleActiveGroupMenu(group);
      },
    });
  };

  useEffect(() => {
    atualizar();
  }, []);

  useEffect(() => {
    debounceSearch('');
  }, [filtroStatus]);

  const renderProdutos = (item, grupo, index) => {
    return (
      <List.Item
        key={item.Id}
        index={index + 1}
        style={{ backgroundColor: theme.colors.backgroundSecondary }}
      >
        <FlexboxGrid>
          <FlexboxGrid.Item colspan={2} style={styleCenter}>
            <Whisper
              speaker={
                <Popover>
                  <b style={{ color: theme.colors.text }}>
                    Clique para alterar a IMAGEM
                  </b>
                </Popover>
              }
            >
              {item?.altered || item?.Imagem || config?.LogoPadrao ? (
                <img
                  style={styleImagem}
                  onClick={() => inserirFoto(item)}
                  src={
                    item.altered
                      ? item?.Imagem
                      : item?.Imagem
                        ? `${IMAGES_PATH}${item.Imagem}`
                        : config?.LogoPadrao
                          ? `${IMAGES_PATH}${config.LogoPadrao}`
                          : ''
                  }
                  alt="..."
                />
              ) : (
                <div
                  onClick={() => inserirFoto(item)}
                  style={{
                    ...noImageStyle,
                    backgroundColor: theme.colors.background,
                  }}
                >
                  <FaFileImage size={38} color={theme.colors.textSecondary} />
                </div>
              )}
            </Whisper>
          </FlexboxGrid.Item>

          <FlexboxGrid.Item
            colspan={10}
            style={{
              ...styleCenter,
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <div style={{ ...titleStyle, color: theme.colors.text }}>
              {item.Descricao}
            </div>
            <div style={{ ...slimText, color: theme.colors.textSecondary }}>
              <div>
                Tipo : {item.TipoProduto}
              </div>
              {item.Sequencia != null && (
                <div>{' Sequencia : ' + item.Sequencia}</div>
              )}
              {item.DataAtualizacao && (
                <div>
                  {' Atualizado em : ' +
                    moment(item.DataAtualizacao).format('DD/MM/YYYY HH:mm')}
                </div>
              )}
              {item.PrecoVenda > 0 && (
                <div style={{ ...mediumText, fontWeight: 'bold' }}>
                  Preço : {parseFloat(item.PrecoVenda).toFixed(2)}
                </div>
              )}
            </div>
          </FlexboxGrid.Item>

          <FlexboxGridItem
            colspan={6}
            style={{ display: 'flex', alignItems: 'center', height: '80px' }}
          >
            <ButtonGroup>
              {!!item.Disponivel ? (
                <CustomButton
                  color={theme.colors.success}
                  appearance="ghost"
                  size="xs"
                  onClick={() => disponibilizar(0, item.Id)}
                >
                  Disponivel
                </CustomButton>
              ) : (
                <CustomButton
                  color="orange"
                  appearance="ghost"
                  size="xs"
                  onClick={() => disponibilizar(1, item.Id)}
                >
                  Indisponivel
                </CustomButton>
              )}
            </ButtonGroup>
          </FlexboxGridItem>

          <FlexboxGrid.Item
            colspan={6}
            style={{
              ...styleCenter,
              justifyContent: 'flex-end',
              paddingRight: '1rem',
            }}
          >
            <CustomButton
              color={theme.colors.warning}
              appearance="ghost"
              size="xs"
              onClick={() => {
                editarProduto(item);
                setGrupoSelecionado(grupo);
              }}
            >
              Editar
            </CustomButton>
            <span style={{ padding: 5, color: theme.colors.textSecondary }}>
              |
            </span>
            <CustomButton
              color={item.Ativo ? theme.colors.danger : theme.colors.success}
              appearance="ghost"
              size="xs"
              onClick={() =>
                ativarDesativarProduto(item.Ativo ? 0 : 1, item.Id)
              }
            >
              {item.Ativo ? 'Inativar' : 'Ativar'}
            </CustomButton>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </List.Item>
    );
  };

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Produtos"
        icon={FaBoxOpen}
        subtitle="Gerencie os produtos do cardápio"
        secondComponent={
          <InputGroup inside style={{ width: '36vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon style={{ color: theme.colors.text }} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <>
            <CustomSelectPicker
              data={dataAtivos}
              defaultValue={'Ativos'}
              value={filtroStatus}
              onChange={(value) => setFiltroStatus(value)}
              searchable={false}
              style={{ marginRight: '10px' }}
            />
            <CustomButton
              appearance="primary"
              onClick={() => {
                setGrupoEdit(null);
                setModalGrupo(true);
              }}
            >
              <PlusIcon style={{ marginRight: '4px' }} /> Adicionar Categoria
            </CustomButton>
            <DuvidasButton tela="produto" />
          </>
        }
      />
      <div style={{ overflowY: 'auto' }}>
        {!buscar ? (
          grupos
            .sort(
              (a, b) =>
                (a.Sequencia != null ? a.Sequencia : Infinity) -
                (b.Sequencia != null ? b.Sequencia : Infinity),
            )
            .map((grupo) => (
              <CustomPanel
                key={grupo.Id}
                header={
                  grupo.Sequencia
                    ? `${grupo.Sequencia} - ${grupo.Descricao}`
                    : `${grupo.Descricao}`
                }
                collapsible
                style={{
                  backgroundColor: theme.colors.backgroundSecondary,
                  marginBottom: '5px',
                }}
              >
                <List hover style={{ overflowY: 'scroll', maxHeight: '50vh' }}>
                  <FlexboxGrid>
                    <FlexboxGrid.Item colspan={12}>
                      <CustomButton
                        appearance="primary"
                        onClick={() => {
                          setItemEdit(null);
                          setModalEditarCadastrar(true);
                          setGrupoSelecionado(grupo);
                        }}
                      >
                        <PlusIcon style={{ marginRight: '4px' }} /> Adicionar
                        Item
                      </CustomButton>
                      <CustomButton
                        style={{ margin: '10px' }}
                        color={theme.colors.text}
                        appearance="ghost"
                        onClick={() => {
                          editCategory(grupo);
                        }}
                      >
                        <FaEdit style={{ marginRight: '4px' }} /> Editar
                        Categoria
                      </CustomButton>
                      <CustomButton
                        style={{ margin: '10px' }}
                        color={theme.colors.text}
                        appearance="ghost"
                        onClick={() => handleShowAlertActiveMenu(grupo)}
                      >
                        {grupo.CardapioAtivo
                          ? 'Desativar no Cardário'
                          : 'Ativar no Cardápio'}
                      </CustomButton>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item colspan={6} style={styleTitleCardGroup}>
                      <div style={{ ...titleStyle, color: theme.colors.text }}>
                        Status das Vendas
                      </div>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item
                      colspan={6}
                      style={{
                        ...styleTitleCardGroup,
                        justifyContent: 'flex-end',
                        paddingRight: '1rem',
                      }}
                    >
                      <div style={{ ...titleStyle, color: theme.colors.text }}>
                        Ações
                      </div>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                  {produtos
                    .filter((item) => item.Grupo === grupo.Id)
                    .map((item, index) => renderProdutos(item, grupo, index))}
                </List>
              </CustomPanel>
            ))
        ) : (
          <List hover>
            {produtos.map((item, index) => renderProdutos(item, index))}
          </List>
        )}
      </div>

      {modalEditarCadastrar && (
        <CadastrarProduto
          modal={modalEditarCadastrar}
          fecharModal={() => setModalEditarCadastrar(false)}
          itemEdit={itemEdit}
          setItemEdit={setItemEdit}
          configuracao={config}
          IdEmpresa={id_empresa}
          grupos={grupos}
          grupoSelecionado={grupoSelecionado}
          produtos={produtos}
          setProdutos={setProdutos}
        />
      )}

      {modalImagem && (
        <GaleriaImagens
          modal={modalImagem}
          fecharModal={() => setModalImagem(false)}
          idEmpresa={id_empresa}
          itemEdit={itemEdit}
          produtos={produtos}
          setProdutos={setProdutos}
        />
      )}

      {modalGrupo && (
        <CadastrarGrupo
          modal={modalGrupo}
          close={() => setModalGrupo(false)}
          id_empresa={id_empresa}
          grupo={grupoEdit}
          setGrupos={setGrupos}
          setGrupo={setGrupoEdit}
          listProducts={consultar}
        />
      )}
    </Container>
  );
}
